/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export const SidebarLinks = (props: { routes: RoutesType[] }): JSX.Element => {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path} className="flex w-full">
            <button
              className={`relative mb-3 w-full flex items-center px-8 py-2 rounded ${
                activeRoute(route.path)
                  ? "bg-brand-500 text-white font-bold"
                  : "bg-gray-200 text-gray-600 font-medium"
              } hover:bg-blue-500 hover:text-white transition-colors`}
            >
              <span>
                {route.icon ? route.icon : <DashIcon />}
              </span>
              <p className="leading-1 ml-4">
                {route.name}
              </p>
              {activeRoute(route.path) && (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              )}
            </button>
          </Link>
        );
      }
    });
  };

  // BRAND
  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;